/**
 * CDN-hosted brand + onboarding image URLs.
 *
 * These SVGs live in the OptiSigns CDN (`scio/assets/…`) rather than the app's `public/` folder so
 * they can be updated without a redeploy. `VITE_CDN_URL` lets non-prod envs point at a different CDN;
 * it falls back to the prod host (same pattern as `playlist-constants` / `useWizardContent`).
 *
 * Logos: two full-logo files (light + dark) because a CDN `<img>` can't be recolored by the app's
 * `.dark` class — the wordmark text color is baked per file. The mark is a single green SVG that
 * reads on both themes.
 */
const CDN_BASE_URL = import.meta.env.VITE_CDN_URL || 'https://cdn.optisigns.com';

export const OPTISIGNS_LOGO = {
  /** Full lockup (cloud mark + wordmark), dark text — for light backgrounds. */
  light: `${CDN_BASE_URL}/scio/assets/logo/optisigns-logo-light.svg`,
  /** Full lockup (cloud mark + wordmark), white text — for dark backgrounds. */
  dark: `${CDN_BASE_URL}/scio/assets/logo/optisigns-logo-dark.svg`,
  /** Collapsed cloud mark only (green, works on light + dark). */
  mark: `${CDN_BASE_URL}/scio/assets/logo/optisigns-mark.svg`,
} as const;

/** Onboarding Q1 ("Who is your primary audience?") illustration graphics. */
export const ONBOARDING_AUDIENCE_IMAGES = {
  employees: `${CDN_BASE_URL}/scio/assets/onboarding/audience-employee.svg`,
  customers: `${CDN_BASE_URL}/scio/assets/onboarding/audience-customer.svg`,
  both: `${CDN_BASE_URL}/scio/assets/onboarding/audience-both.svg`,
} as const;
